var _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorksBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 625,
    height: 700,
    viewBox: "0 0 625 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.5,
    cy: 350,
    rx: 312.5,
    ry: 350,
    fill: "url(#paint0_radial_16_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_8",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.5 350) rotate(90) scale(350 312.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#763CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#320F85",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksBack);
export default __webpack_public_path__ + "static/media/worksBack.2004bbbef0104ec376c69ac7e36ef887.svg";
export { ForwardRef as ReactComponent };